export const generatedScaleoImportReport = {
  "generatedAt": "2026-05-22T15:44:29.033Z",
  "offersFetched": 314,
  "storesGenerated": 313,
  "sheetRows": 1264,
  "sheetRowsMatched": 1105,
  "sheetRowsUnmatched": 25,
  "workbookActionRows": 954,
  "workbookPromoRows": 304,
  "googleSheetRows": 6,
  "unmatchedOffers": [
    "Compensair",
    "GetTransfer.com",
    "Radical Storage",
    "TicketNetwork",
    "Aviasales",
    "Yesim",
    "Economybookings.com",
    "intui.travel",
    "EKTA",
    "WeGoTrip",
    "BikesBooking.com",
    "GetRentacar.com",
    "Kiwitaxi",
    "AutoEurope (EU,UK)",
    "Airalo (WEB)",
    "QEEQ",
    "AirHelp",
    "SEARADAR",
    "Tiqets",
    "onliner.by",
    "Poison Drop",
    "Whatnot Affiliates",
    "Vidline Inc. - Creator",
    "UniPin Affiliate Hub",
    "Thrifty Car Rental MX (MX, US & CA)",
    "Talkpal - AI Language Learning",
    "SportsBreaks",
    "Simply Sensitivity Checks UK",
    "The Palace Company",
    "Novakid TR",
    "Novakid IL",
    "Novakid Global ARABIC",
    "MFI Medical",
    "ManyChat",
    "Lenovo Colombia",
    "KKday Australia",
    "Joybuy",
    "iDefend",
    "Hotels VIVA ( GLOBAL )",
    "Modlily",
    "REDMOND",
    "Леонардо",
    "Много Мебели",
    "ПрезиДЕНТ",
    "FUNDAY",
    "Preply - Creator",
    "Joom",
    "Brain.fm",
    "italki Global",
    "Oojo",
    "CreditVana",
    "Keeprix",
    "WPS SOFTWARE PTE.LTD.",
    "EssayDone - AI Writer & Humanizer",
    "ArkThinker",
    "365 Financial Analyst",
    "SafeShellVPN",
    "GearUP",
    "BadCreditLoans.com",
    "Easyship Ambassador Program",
    "CapCut Affiliate Program",
    "Preply Learners",
    "AppSumo",
    "LingChat",
    "Jackery FR",
    "Jackery NL",
    "Jackery ES",
    "Jackery",
    "Sider",
    "Bongacams PerSignup + RevShare",
    "ЦВЕТ ДИВАНОВ",
    "Art for introvert",
    "Merion Academy",
    "Точка Знаний",
    "AMAZING RED",
    "Mark Formelle (Казахстан)",
    "Xcom-shop",
    "Kassir",
    "Ormatek",
    "Авторусь",
    "Aravia",
    "Polza.ru",
    "2MOOD",
    "4 Лапы",
    "PULT.RU",
    "ШЕФМАРКЕТ",
    "Pharmacosmetica",
    "СберЗдоровье Анализы",
    "Институт Медицины",
    "Нутрициолог с 0 до PRO",
    "Psycholesson",
    "Trivago AU",
    "WowTickets-US",
    "AirAsia Travel",
    "Edwica",
    "Otello",
    "Московский Институт Психологии",
    "GrownAlchemist",
    "BridgeResort(brsochi)",
    "Абакус центр",
    "Letu.ru",
    "Билайн",
    "KRUPS",
    "Codashop Affiliate Program",
    "Lightinthebox",
    "InVideo",
    "Airalo",
    "SPanel",
    "Jackery (United States)",
    "Temu Affiliate Program",
    "Страховой Дом ВСК",
    "Авито",
    "Befree",
    "Interra",
    "Хекслет",
    "Videoforme",
    "TopAcademy",
    "Сотка",
    "Skyeng",
    "SEKTA SCHOOL",
    "PSYCHODEMIA",
    "BONNIE & SLIDE",
    "АльфаБанк Дебетовая карта",
    "АльфаБанк Кредитная карта",
    "Автокод",
    "Miniopros RU CIS CPL",
    "Huggies",
    "В.Опрос",
    "Web Offer Planner5D.Com [All GEO]",
    "Banggood",
    "Planner5D || Design School [All GEO]",
    "ALIEXPRESS",
    "INTERNETOPROS",
    "DHGATE"
  ],
  "unmatchedDomains": [
    "AvidAngler.ru",
    "algoritmika.org",
    "anywayanyday.com",
    "beeline.ru",
    "kids.skillbox.ru",
    "kolesa-darom.ru",
    "kontur.ru",
    "letoile.kz",
    "level.travel",
    "lgcity.ru",
    "litnet.com",
    "loccitanebresil.ru",
    "maxidom.ru",
    "onliner.by",
    "ostrovok.ru",
    "ourgold.ru",
    "priem.menu",
    "reg.ru",
    "sf.education",
    "smitup.ru",
    "talentsy.ru",
    "tetrika-school.ru",
    "top-academy.ru",
    "umschool.one",
    "x5paket.ru"
  ]
};
